import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { MobileCard } from "@ui/components/card";
import { IconText } from "@ui/components/info/IconText";
const formatTemp = (value) => {
    if (value === null || value === undefined)
        return "-";
    return `${value.toFixed(1)}°C`;
};
const TempValue = ({ symbol, value, }) => (React.createElement(Box, { sx: { display: "flex", alignItems: "center", gap: 0.5 } },
    React.createElement(Typography, { variant: "body2", color: "text.secondary", fontWeight: 600 }, symbol),
    React.createElement(Typography, { variant: "body2" }, value)));
export const ReportCard = ({ row, selectedNodes }) => {
    const showApNames = selectedNodes.length > 1;
    return (React.createElement(MobileCard, null,
        React.createElement(IconText, { icon: "solar:calendar-linear", text: row.period }),
        React.createElement(Box, { sx: {
                display: "flex",
                flexDirection: "row",
                flexWrap: "nowrap",
                gap: 1,
                overflowX: "auto",
                pb: 0.5,
                mx: -0.5,
                px: 0.5,
                WebkitOverflowScrolling: "touch",
            } }, selectedNodes.map((ap) => {
            const apData = row[String(ap.value)];
            return (React.createElement(Box, { key: String(ap.value), sx: {
                    flex: "0 0 auto",
                    minWidth: 140,
                    bgcolor: "#F4F6F8",
                    borderRadius: 2,
                    px: 1.5,
                    py: 1,
                } },
                showApNames && (React.createElement(Typography, { variant: "body1", color: "primary.darker", noWrap: true }, ap.label)),
                React.createElement(Grid, { container: true, spacing: 1 },
                    React.createElement(Grid, { size: 4 },
                        React.createElement(TempValue, { symbol: "{\u2212}", value: formatTemp(apData === null || apData === void 0 ? void 0 : apData.minTemp) })),
                    React.createElement(Grid, { size: 4 },
                        React.createElement(TempValue, { symbol: "{\u2713}", value: formatTemp(apData === null || apData === void 0 ? void 0 : apData.avgTemp) })),
                    React.createElement(Grid, { size: 4 },
                        React.createElement(TempValue, { symbol: "{+}", value: formatTemp(apData === null || apData === void 0 ? void 0 : apData.maxTemp) })))));
        }))));
};
